import styled from 'styled-components'
import { sc } from 'utils'

export default styled.input.attrs({ type: 'radio' })`
  flex: none;

  width: 14px;
  height: 14px;
  margin: 0;

  background-color: white;
  background-repeat: no-repeat;
  background-position: center;
  border: 1px solid var(--green);
  border-radius: 50%;

  cursor: pointer;
  appearance: none;
  transition: background-color 0.2s;

  :checked::before {
    content: '';
    display: block;

    width: 8px;
    height: 8px;
    margin: 2px;

    border-radius: inherit;
    background-color: var(--green);
  }

  :hover {
    background-color: var(--green_0-1);
  }

  :focus-visible {
    outline: 2px solid var(--green_0-5);
  }
`

export const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  font: var(--400-12);
  cursor: pointer;

  span:last-of-type:not(:only-of-type) {
    color: var(--red);
    font: var(--400-11);

    :empty {
      display: none;
    }
  }
`

export const ActiveRadioLabel = styled(RadioLabel)<{ active: boolean; hiddenRadio?: boolean }>`
  color: var(--text);
  flex: 1;
  padding: 16px 10px;
  border: 1px solid var(--light-gray);

  ${sc('active', 'border-color: var(--green); background-color: var(--very-light-green);')}
  ${sc('hiddenRadio', 'input { display: none; }')}
  
  svg {
    color: var(--green);
  }

  :first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  :last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`

export const CombinedRadios = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  > span {
    color: var(--gray);
  }

  > div {
    display: flex;
  }
`
